import { gameArea } from "../utils/gameArea";
import game from "../game";
import CRTShader from "../shaders/CRT";
import SoundManager from "../managers/SoundManager";
import MainMenuScene from "./MainMenuScene";

export enum TextBlurbStates {
    INTRO = 0,
    ENDING = 1
}

export default class TextBlurbScene extends Phaser.Scene {
    titleText: Phaser.GameObjects.Text;
    mainText: Phaser.GameObjects.Text;
    CRTPipeline: CRTShader;
    state: TextBlurbStates;
    continueText: Phaser.GameObjects.Text;

    constructor(){
        super({ key: "TextBlurbScene" });

    }

    preload(){
        const renderer = < Phaser.Renderer.WebGL.WebGLRenderer>game.renderer;
        this.CRTPipeline = <CRTShader>renderer.getPipeline('CRT');
    }

    create(){
        this.sys.canvas.style.cursor = "auto";
        this.cameras.main.setRenderToTexture(this.CRTPipeline);

        const tenth = gameArea.screenHeight/10;

        this.titleText = this.add.text(gameArea.screenWidth/2,tenth*3,"", { fontFamily: "Practice", fontSize: 120, stroke: '#000', strokeThickness: 3 });
        this.titleText.setOrigin(0.5);

        this.mainText = this.add.text(gameArea.screenWidth/2,gameArea.screenHeight/2,"", { fontFamily: "Practice", fontSize: 42, stroke: '#000', strokeThickness: 1, textAlign: "right" });
        this.mainText.setOrigin(0.5);
        this.mainText.setAlign("center");
        this.continueText = this.add.text(gameArea.screenWidth/2,tenth*9,"Continue.", { fontFamily: "Practice", fontSize: 48, stroke: '#000', strokeThickness: 3 })
        this.continueText.setOrigin(0.5);
        this.continueText.setInteractive();
        this.continueText.input.cursor = "pointer";
        this.continueText.on('pointerdown', ()=>{
            SoundManager.playSfx('menuSelect');
            const gscene = <MainMenuScene>this.scene.get('MainMenuScene');
            gscene.scene.resume();
            gscene.scene.setVisible(true);
            gscene.reinit();
            this.sys.canvas.style.cursor = "auto";
            this.scene.sleep();
        });

        this.setState(TextBlurbStates.INTRO);
    }

    setState(newState: TextBlurbStates){
        this.sys.canvas.style.cursor = "auto";

        switch(newState){
            case TextBlurbStates.INTRO:
                this.titleText.setVisible(false);
                this.mainText.setVisible(true);
                this.mainText.setText(
                    `
In the distant future humans live an
exclusively digital existence. Physical
bodies are a privilege enjoyed by the rich,
the powerful and those who win at...
                    `);
            break;
            case TextBlurbStates.ENDING:
                this.titleText.setText("THE END.");
                this.titleText.setVisible(true);
                this.mainText.setVisible(true);
                this.mainText.setText(`
You are now among the fortunate few.
Able to finally live - and to at last...

die.
                `);
            break;
        }
        this.state = newState;
        return this;
    }

    update(time,delta){
        this.CRTPipeline.time+=delta;
    }

}